module.exports = __webpack_public_path__ + "static/img/iclude.0a0a602.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/service/iclude.png
// module id = hQTe
// module chunks = 1